export default {
  workspace: 'My Burn Center Workspace',
  surveyManagment: 'Survey Managment',
  reportManagment: 'Report Managment',
};
